<myp-inline-loader [loading]="loading" height="400px" spinnerName="eventDetailLoader"></myp-inline-loader>
@if (!event && !loading) {
  <div class="w-full h-full d-flex justify-content-center align-items-center">
    <span>No event found.</span>
  </div>
}
@if (event && !loading) {
  @if (address) {
    <div style="height: 300px">
      @if (latLong) {
        <google-map height="300px" width="100%" [zoom]="15" [center]="{ lat: latLong.lat, lng: latLong.long }">
          <map-marker [position]="{ lat: latLong.lat, lng: latLong.long }"></map-marker>
        </google-map>
      }
    </div>
  }
  @if (!event.cloud_only || user.active_subscription) {
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <fui-heading [text]="event.title_events" [level]="5"></fui-heading>
          @if (event.startdate_events && event.enddate_events && event.startdate_events == event.enddate_events) {
            @if (event.startdate_events && event.starttime_events) {
              <span class="fui-eyebrow">{{ event.start_utc | date: "MMM Do h:mma" : false }}</span>
            }
            @if (event.startdate_events && !event.starttime_events) {
              <span class="fui-eyebrow">{{ event.start_utc | date: "MMM Do" : false }}</span>
            }
            @if (event.endtime_events) {
              <span class="fui-eyebrow">- {{ event.end_utc | date: "h:mma" : false }}</span>
            }
          }
          @if (event.startdate_events && event.enddate_events && event.startdate_events != event.enddate_events) {
            @if (event.startdate_events && event.starttime_events) {
              <span class="fui-eyebrow">{{ event.start_utc | date: "MMM Do h:mma" : false }}</span>
            }
            @if (event.startdate_events && !event.starttime_events) {
              <span class="fui-eyebrow">{{ event.start_utc | date: "MMM Do" : false }}</span>
            }
            @if (event.enddate_events && event.endtime_events) {
              <span class="fui-eyebrow">- {{ event.enddate_events + " " + event.endtime_events | date: "MMM Do h:mma" : false }}</span>
            }
            @if (event.enddate_events && !event.endtime_events) {
              <span class="fui-eyebrow">- {{ event.enddate_events | date: "MMM Do" : false }}</span>
            }
          }
          @if (event.startdate_events && !event.enddate_events) {
            @if (event.startdate_events && event.starttime_events) {
              <span class="fui-eyebrow">{{ event.start_utc | date: "MMM Do h:mma" : false }}</span>
            }
            @if (event.startdate_events && !event.starttime_events) {
              <span class="fui-eyebrow">{{ event.start_utc | date: "MMM Do" : false }}</span>
            }
          }
          @if (this.geocodeResult && this.geocodeResult.formatted_address) {
            <div class="text-center">{{ this.geocodeResult.formatted_address }}</div>
          }
          @if (!this.geocodeResult) {
            <div class="text-center">{{ address }}</div>
          }
          <div class="text-left m-y-20">
            <div>
              @if (event.fb_event_url) {
                <a class="bold" [href]="event.fb_event_url">{{ event.fb_event_url }}</a>
              }
            </div>
            <div>
              @if (event.website_events) {
                <a class="bold" [href]="event.website_events">{{ event.website_events }}</a>
              }
            </div>
            <div>
              @if (event.email_events) {
                <a class="bold" [href]="'mailto:' + event.email_events">{{ event.email_events }}</a>
              }
            </div>
          </div>
          <div class="event-detail" [innerHTML]="html | safe: 'html'"></div>
        </div>
      </div>
    </div>
  }
  @if (event.cloud_only && !user.active_subscription) {
    @if (!user.active_subscription) {
      <div class="row h-100">
        <div class="col h-100 text-center">
          <div class="h-100 d-flex justify-content-center align-items-center">
            <div style="max-width: 600px; margin: 10px">
              <div
                style="
                  background-image: url(https://pae-web.presonusmusic.com/uploads/products/media/images/presonus-sphere-website-0321-07.png);
                  background-size: cover;
                  background-position: center;
                  padding: 150px 50px;
                  border-radius: 20px;
                "
              >
                <h1 class="gothic c-white" style="text-shadow: 0px 0px 5px black">{{ "newdash.exclusive_content_livestreams" | translate | uppercase }}</h1>
              </div>
              <p class="m-t-20">The event you are trying to view is for Studio One Pro+ members only.</p>
              <button class="btn btn-primary" (click)="upgrade()">{{ "newdash.get_sphere" | translate: { subName: env.studioOnePlusBrandName } }}</button>
            </div>
          </div>
          <!-- <br />
          <img class="w-100" style="max-width: 800px; border-radius: 20px;" src="https://pae-web.presonusmusic.com/uploads/products/media/images/presonus-sphere-website-0321-08-MOBILE.jpg" /> -->
        </div>
      </div>
    }
  }
}
